// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"b0364621","453":"2f9ba6e0","631":"795917c8","834":"cf733d23","952":"a11d22cf"}[chunkId] + ".chunk.js";
};